import { memoizeFunction, getRTL } from '@fluentui/react/lib/Utilities';
import { IIconProps } from '@fluentui/react/lib/Icon';

const cachedIconProps = memoizeFunction(
  (iconName: string, iconColor?: string, hideIcon?: boolean, flip?: boolean): IIconProps => {
    // TODO: 2192132 - Remove setting the color attribute once the CSS from CXE is updated to read the fill color
    return {
      iconName,
      ...((iconColor || hideIcon || flip) && {
        styles: {
          root: {
            ...(iconColor && { color: iconColor, fill: iconColor }),
            ...(hideIcon && { visibility: 'hidden' }),
            ...(flip && { '-webkit-transform': 'scaleX(-1)', transform: 'scaleX(-1)' }),
          },
        },
      }),
    };
  }
);

export const iconNameToIconProps = (
  iconName?: string,
  iconColor?: string,
  hideIcon?: boolean,
  flipInRtl?: boolean
): IIconProps | undefined => {
  const isRTL = getRTL();
  return iconName ? cachedIconProps(iconName, iconColor, hideIcon, flipInRtl && isRTL) : undefined;
};
